// Phase 6.C-Track A 잔여 — TopNav 프로필 dropdown 항목 → /profile 라우트.
// /me 응답 (= AuthContext.me) 의 사장 본인 정보 + 소속 회사·역할 표시.
// 편집 기능 없음 (read-only 카드). 향후 별도 trace 에서 비밀번호 변경·이름 수정 등 확장.

import { Badge, Button } from '../components/primitives';
import { useAuth } from '../auth/AuthContext';

const ROLE_LABEL: Record<string, string> = {
  owner: '사장 (owner)',
  staff: '직원 (staff)',
};

export function ProfileRoute() {
  const auth = useAuth();
  const me = auth.me;
  const user = me?.user;
  const orgs = me?.organizations ?? [];

  return (
    <div style={{ padding: '24px 0', maxWidth: 720, margin: '0 auto' }}>
      <h1
        style={{
          fontSize: 22,
          fontWeight: 700,
          color: 'var(--fg-1)',
          margin: '0 0 6px',
          letterSpacing: '-0.01em',
        }}
      >
        내 프로필
      </h1>
      <div style={{ fontSize: 13, color: 'var(--fg-3)', marginBottom: 20 }}>
        계정 정보와 소속 회사를 확인합니다. 정보 수정은 추후 지원 예정입니다.
      </div>

      <section
        style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--border-weak)',
          borderRadius: 'var(--radius-lg)',
          padding: 20,
          display: 'flex',
          flexDirection: 'column',
          gap: 14,
          marginBottom: 16,
        }}
      >
        <SectionTitle>계정</SectionTitle>
        <Field label="이메일" value={user?.email ?? '-'} />
        <Field label="이름" value={user?.name || '(미입력)'} />
        <Field
          label="역할"
          value={
            <Badge variant={auth.role === 'owner' ? 'success' : 'default'}>
              {ROLE_LABEL[auth.role] ?? auth.role}
            </Badge>
          }
        />
      </section>

      <section
        style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--border-weak)',
          borderRadius: 'var(--radius-lg)',
          padding: 20,
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          marginBottom: 16,
        }}
      >
        <SectionTitle>소속 회사 ({orgs.length})</SectionTitle>
        {orgs.length === 0 ? (
          <div style={{ fontSize: 13, color: 'var(--fg-3)' }}>소속 회사가 없습니다.</div>
        ) : (
          orgs.map((o) => (
            <div
              key={o.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 12px',
                background: 'var(--bg-subtle)',
                borderRadius: 'var(--radius-md)',
              }}
            >
              <div>
                <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--fg-1)' }}>
                  {o.name}
                </div>
                {o.suspended && (
                  <div style={{ fontSize: 12, color: 'var(--danger)', marginTop: 2 }}>
                    정지됨
                  </div>
                )}
              </div>
              <Badge variant={o.role === 'owner' ? 'success' : 'default'}>
                {ROLE_LABEL[o.role] ?? o.role}
              </Badge>
            </div>
          ))
        )}
      </section>

      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <Button variant="secondary" onClick={auth.logout}>
          로그아웃
        </Button>
      </div>
    </div>
  );
}

function SectionTitle({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        fontSize: 13,
        fontWeight: 600,
        color: 'var(--fg-2)',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
      }}
    >
      {children}
    </div>
  );
}

function Field({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <div
        style={{
          fontSize: 12,
          color: 'var(--fg-3)',
          width: 80,
          flexShrink: 0,
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: 14, color: 'var(--fg-1)' }}>{value}</div>
    </div>
  );
}
